import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// 重置样式，引人定义好的css
import '@/assets/css/reset.css'
import '@/assets/css/base.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
